import { playOnce } from './playOnce';
import { render } from './render';
import { resolveUrl } from './resolveUrl';
import { sineTone } from './sineTone';
import { supported, extensions, validateFormats } from './supported';

/**
 * Utilities that work with sounds.
 * @namespace utils
 */
export default {
    playOnce,
    render,
    resolveUrl,
    sineTone,
    supported,
    extensions,
    validateFormats
};
